import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import { Autocomplete, Button, FormControl, InputLabel, IconButton, MenuItem, Paper, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Nabvar from "../../../common/Nabvar";
import Sidebar from "../../../common/Sidebar";
import axios from "../../../config/authaxios";
import { getCategoryAction } from "../../../redux/coupon/GetCategoryRTK";
import Body from "../../../ui/Body";
import CreateCategory from "./CreateCategory";
import DeleteCategory from "./DeleteCategory";
import UpdateCategory from "./UpdateCategory";


// global veriables---->
let propsData = {};

export default function Categories() {
  // states------->
  const [createCategory, setCreateCategory] = useState(false);
  const [updateCategory, setUpdateCategory] = useState(false);
  const [deleteCategory, setDeleteCategory] = useState(false);

  const navigate = useNavigate();
  const dispatchRTK = useDispatch();
  const getCategorySelcter = useSelector((state) => state.getCategory);
  const { loading, data } = getCategorySelcter;
  const createCategorySelector = useSelector(state => state.createCategory);
  const { status } = createCategorySelector;
  const deleteCategoryRTK = useSelector((state) => state.deleteCategory);
  const { status: statusDeleteCategory } = deleteCategoryRTK;
  const updateCategorySelector = useSelector((state) => state.updateCategory);
  const { status: updateCategoryStatus, data: updateCategoryData } = updateCategorySelector;

  const [publishers, setPublishers] = useState([]);
  const [selectedPublisher, setSelectedPublisher] = useState(null);
  const [publisherCategoryActive, setPublisherCategoryActive] = useState(true);

  const headerCellSx = { bgcolor: '#DC8449', color: '#fff', fontWeight: 600 };




  // useEffect
  useEffect(() => {
    axios.get(`/admin/publishers/name-id`).then((res) => {
      if (res.data.status_code == 401) {
        localStorage.clear();
      }
      if (res.data.status) {
        setPublishers(res.data.response || res.data.data || []);
      } else {
        setPublishers([]);
      } 
    }).catch((err) => {
      console.error("Error fetching publishers:", err);
      setPublishers([]);
    });
  }, []);

  useEffect(() => {
    dispatchRTK(
      getCategoryAction({
        publisherId: selectedPublisher?._id,
        isDeleted: !publisherCategoryActive,
      })
    );
  }, [
    status,
    statusDeleteCategory,
    updateCategoryStatus,
    updateCategoryData,
    selectedPublisher,
    publisherCategoryActive,
  ]);

  return (
    <>
      {/* navigation section */}
      <section>
        <Sidebar />
        <Nabvar />
      </section>

      {/* body */}
      <Body>
        <Stack direction="row" spacing={2} alignItems="center" sx={{ my: 2 }}>
          <Button
            variant="contained"
            onClick={() => setCreateCategory(true)}
          >
            Create Category
          </Button>

          <Autocomplete
            sx={{ width: 300 }}
            options={publishers}
            getOptionLabel={(option) => option?.name || ""}
            isOptionEqualToValue={(option, value) => option?._id === value?._id}
            value={selectedPublisher}
            onChange={(event, newValue) => setSelectedPublisher(newValue)}
            renderInput={(params) => (
              <TextField {...params} label="Filter by Publisher" size="small" />
            )}
          />

          {selectedPublisher && (
            <FormControl size="small" sx={{ minWidth: 140 }}>
              <InputLabel id="publisher-category-active-label">Status</InputLabel>
              <Select
                labelId="publisher-category-active-label"
                label="Status"
                value={publisherCategoryActive ? "active" : "deleted"}
                onChange={(e) => setPublisherCategoryActive(e.target.value === "active")}
              >
                <MenuItem value="active">Active</MenuItem>
                <MenuItem value="deleted">Deleted</MenuItem>
              </Select>
            </FormControl>
          )}
        </Stack>

        <TableContainer component={Paper} sx={{ bgcolor: '#fff' }} elevation={0}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={headerCellSx}>S. No.</TableCell>
                <TableCell sx={headerCellSx}>ID</TableCell>
                <TableCell sx={headerCellSx}>Name</TableCell>
                <TableCell sx={headerCellSx}>Image</TableCell>
                <TableCell sx={headerCellSx}>Cashback %</TableCell>
                <TableCell sx={headerCellSx}>Position</TableCell>
                <TableCell sx={headerCellSx}>Popular Category</TableCell>
                <TableCell sx={headerCellSx}>Edit Category</TableCell>
                <TableCell sx={headerCellSx}>Delete Category</TableCell>
                <TableCell sx={headerCellSx}>Created At</TableCell>
                <TableCell sx={headerCellSx}>Updated At</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* Every category returned by the API is rendered here - no
                  pagination or virtualization limiting the row count. */}
              {(data || []).map((row, index) => {
                const isPublisherDeletedCategory =
                  !!selectedPublisher && !!row?.is_deleted;

                return (
                  <TableRow key={row._id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{row._id}</TableCell>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>
                      {row.image ? (
                        <img src={row.image} width="50px" alt={row.name || ""} />
                      ) : null}
                    </TableCell>
                    <TableCell>{row.cashback_percentage}</TableCell>
                    <TableCell>{row.position || "---"}</TableCell>
                    <TableCell>
                      {(selectedPublisher
                        ? row.is_popular_category
                        : row.popular_category)
                        ? "Yes"
                        : "No"}
                    </TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() => {
                          setUpdateCategory(true);
                          propsData = selectedPublisher
                            ? {
                                category_id: row._id,
                                name: row.name,
                                cashback_percentage: row.cashback_percentage,
                                position: row.position,
                                image: row.image,
                                is_popular_category: row.is_popular_category,
                                isPublisherCategory: true,
                              }
                            : {
                                catId: row._id,
                                name: row.name,
                                cashback_percentage: row.cashback_percentage,
                                position: row.position,
                                image: row.image,
                                popular_category: row.popular_category,
                              };
                        }}
                      >
                        <EditIcon color="primary" />
                      </IconButton>
                    </TableCell>
                    <TableCell>
                      {isPublisherDeletedCategory ? (
                        <IconButton
                          onClick={() => {
                            setDeleteCategory(true);
                            propsData = {
                              category_id: row._id,
                              is_deleted: false,
                              isPublisherCategory: true,
                            };
                          }}
                        >
                          <RestoreFromTrashIcon color="success" />
                        </IconButton>
                      ) : (
                        <IconButton
                          onClick={() => {
                            setDeleteCategory(true);
                            propsData = selectedPublisher
                              ? {
                                  category_id: row._id,
                                  is_deleted: true,
                                  isPublisherCategory: true,
                                }
                              : {
                                  catId: row._id,
                                  is_deleted: true,
                                };
                          }}
                        >
                          <DeleteIcon color="error" />
                        </IconButton>
                      )}
                    </TableCell>
                    <TableCell>{row.created_at}</TableCell>
                    <TableCell>{row.updated_at}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>


      </Body>

      {/* modals */}
      {
        updateCategory && (
          <UpdateCategory
            updateCategory={updateCategory}
            setUpdateCategory={setUpdateCategory}
            propsData={propsData}
          />
        )
      }
      {
        createCategory && (
          <CreateCategory
            createCategory={createCategory}
            setCreateCategory={setCreateCategory}
          />
        )
      }
      {
        deleteCategory && (
          <DeleteCategory
            deleteCategory={deleteCategory}
            setDeleteCategory={setDeleteCategory}
            propsData={propsData}
          />
        )
      }
    </>
  );
}
